import { render, staticRenderFns } from "./truncate.vue?vue&type=template&id=87f8d542&lang=pug"
import script from "./truncate.vue?vue&type=script&lang=js"
export * from "./truncate.vue?vue&type=script&lang=js"
import style0 from "./truncate.vue?vue&type=style&index=0&id=87f8d542&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports